import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContentBlock16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconContentBlock16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.5 6.997H9V1.995h4a2 2 0 0 1 2 2v3.002zm.5-4.002v3.002h4V3.995a1 1 0 0 0-1-1zM7 8V4H3a1 1 0 0 0-1 1v3zm0 1H2v3a1 1 0 0 0 1 1h4.001zm1 0v4h4a1 1 0 0 0 1-1V9zm5.5-1h.5v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5v5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContentBlock16);
